


















import { Component, Vue } from 'vue-property-decorator';

@Component

export default class GlowBoxRight extends Vue {
  /* TODO: Move data to service */
 private data() {
   return {
     gaugeF: {
       url: require('../assets/home-mech/gauge-F-glow_18x18.png'),
       alt: 'Gear F Glow',
     },
     gaugeG: {
       url: require('../assets/home-mech/gauge-F-glow_18x18.png'),
       alt: 'Gear F Glow',
     },
     gaugeH: {
       url: require('../assets/home-mech/gauge-G-glow_28x24.png'),
       alt: 'Gear H Glow',
     },
   };
 }
}
